import React, {useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {FileUploadProps, IFileUploadDialogProps} from "./types";
import {DaButton} from "../form";
import {FileUpload} from "./FileUpload";
import {IMessagePanelProps, MessageBox, MsgBoxType} from "../dialog";
import Box from "@mui/material/Box";

export const FileUploadDialog: React.FC<IFileUploadDialogProps> = (
    {
        isOpen = false,
        onClose,
        title = "Choose File to Upload",
    }: IFileUploadDialogProps
) => {
    const [selFiles, setSelFiles] = React.useState<FileList | undefined>(undefined);
    const [msgBoxOpen, setMsgBoxOpen] = React.useState<boolean>(false);
    const [msgBoxProps, setMsgBoxProps] = useState<IMessagePanelProps>({message: ""});

    const handleClose = () => {
        onClose("cancel");
        setSelFiles(undefined);
    };

    const handleOk = () => {
        onClose("ok", selFiles);
        setSelFiles(undefined);
    };

    const msgBox_Close = (value?: string) => {
        setMsgBoxOpen(false);
    }

    const msgBox_Show = (message: string, title?: string, type?: MsgBoxType) => {
        setMsgBoxProps({
            message: message,
            title: title,
            type: type,
        })
        setMsgBoxOpen(true);
    }

    const hasExtension = (fileName: string) => {
        const extensions = fileUploadProp.accept.replace(/\s/g, '').replace(/,/g, '|');
        return (new RegExp('(' + extensions + ')$', 'i')).test(fileName);
    }

    const selFilesIsValid = (fileList: FileList) => {
        for (let i = 0; i < fileList.length; i++) {
            if (!hasExtension(fileList[i].name)) {
                setSelFiles(undefined);
                msgBox_Show(
                    `Invalid file type selected, please select a file ` +
                            `with one of the following extensions:\n${fileUploadProp.accept}`,
                    "Invalid File Type...",
                    "error"
                );
                return false;
            }
        }
        return true;
    }

    const fileUploadProp: FileUploadProps = {
        accept: ".docx, .pdf, .txt",
        onFilesSelect: (e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.files &&
                e.target.files.length > 0 &&
                selFilesIsValid(e.target.files)) {
                setSelFiles(e.target.files);
            }
        },
        onFilesDrop: (e: React.DragEvent<HTMLElement>) => {
            if (e.dataTransfer.files &&
                e.dataTransfer.files.length > 0 &&
                selFilesIsValid(e.dataTransfer.files)) {
                setSelFiles(e.dataTransfer.files);
            }
        }
    };

    return (
        <>
            <Dialog
                open={isOpen}
                onClose={handleClose}
                maxWidth={"md"}
                aria-labelledby="dialog-box-title"
                aria-describedby="dialog-box-description"
            >
                <DialogTitle
                    id="dialog-box-title"
                    sx={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "start"
                    }}
                >
                    {title}
                </DialogTitle>
                <DialogContent sx={{whiteSpace: "pre-line"}}>
                    <FileUpload {...fileUploadProp} />
                    <Box>{selFiles && (`Selected File:\n${selFiles[0].name}`)}</Box>
                </DialogContent>
                <DialogActions>
                    <DaButton buttonStyle="secondary" variant={"outlined"} autoFocus onClick={handleClose}>Cancel</DaButton>
                    <DaButton buttonStyle="primary" variant={"outlined"} onClick={handleOk}>OK</DaButton>
                </DialogActions>
            </Dialog>
            <MessageBox
                isOpen={msgBoxOpen}
                onClose={msgBox_Close}
                {...msgBoxProps}
            />
        </>
    );
}